import React from 'react';
import { useTheme } from 'styled-components';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';

export const RecommendedBadge: React.FC = () => {
  const theme = useTheme();

  return (
    <Badge
      size="small"
      bgColor={theme.token['blue.3']}
      label={
        <SmallText color={theme.token.colorPrimaryText} fontWeight={500}>
          Recommended
        </SmallText>
      }
    />
  );
};
